import { api } from '@/api'
import { Period } from '@/ui-kit'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

export function useUserReferralPoints(period: Period): UseQueryResult<Record<Period, Record<string, string>>> {
  return useQuery({
    queryKey: ['useUserReferralPoints', period],
    queryFn: () => api.get(`/user/stats/referral-points?period=${period}`),
    retry: 0
  })
}
